import * as React from 'react';
import InputMask from '../InputMask';
import Tooltip from '../Tooltip';
import { validators } from '../../../utils/ehrValidators';
import { BlurEvent } from '../../../utils/customInterface';
import { isNumber } from 'lodash-es';

export interface Props {
    onChange: (value: string, field: string) => void;
    onBlur?: () => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onCheck?: (value: string) => void;
    field: string;
    label: string;
    value: string | number;
    type?: string;
    id?: string;
    rules?: Object;
    extendClass?: Array<string>;
    placeHolder?: string;
    mask?: string;
    inputCheck?: React.ReactNode;
    password?: boolean;
    disabled?: boolean;
    triggerCheckError?: boolean;
    triggerClearError?: boolean;
    relatedValue?: string; // Use in claim
    headIcon?: string; // Use to show the icon $ with the inputbox for money amount
    errorMessage?: string; //Use to show tooltip error
    autoComplete?: string;
}

export interface State {
    errors: Array<string>;
    focusing: boolean;
}

class InputBox extends React.Component<Props, State> {
    maskString: string;
    constructor(props: Props) {
        super(props);
        this.state = {
            errors: new Array<string>(),
            focusing: false
        };
    }

    componentDidMount() {
        const { mask } = this.props;
        this.maskString = mask ? mask.replace(/[0-9]|[a-z]|[A-Z]/g, '_') : '';
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        const { triggerCheckError, triggerClearError, relatedValue } = this.props;
        const { rules } = nextProps;
        if (triggerCheckError !== nextProps.triggerCheckError || (relatedValue !== nextProps.relatedValue)) {
            if (rules) {
                let result = new Array<string>();
                Object.keys(rules).forEach(rule => {
                    const error = isNumber(nextProps.value) ? '' : validators(rule, rules[rule], nextProps.value);
                    if (error.length > 0) {
                        result.push(error);
                    }
                });
                this.setState({
                    errors: result
                });
            }
        }
        if (triggerClearError !== nextProps.triggerClearError) {
            this.setState({
                errors: new Array<string>()
            });
        }
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        let value = this.formatValue(e.target.value);
        if (e.target.value === this.maskString) {
            value = '';
        }
        this.props.onChange(value, this.props.field);
    }

    handleBlur = (e: BlurEvent<HTMLInputElement>): void => {
        const { rules, onBlur } = this.props;
        if (onBlur) {
            onBlur();
        }
        let value = this.formatValue(e.target.value);
        if (rules) {
            let result = new Array<string>();
            Object.keys(rules).forEach(rule => {
                const error = validators(rule, rules[rule], value);
                if (error.length > 0) {
                    result.push(error);
                }
            });
            this.setState({
                errors: result,
                focusing: false
            });
        }
        if (this.props.onCheck) {
            this.props.onCheck(value);
        }
    }

    formatValue = (value: string): string => {
        const { headIcon } = this.props;
        return headIcon ? value === headIcon ? '' : value.replace(`${headIcon} `, '') : value;
    }

    handleFocus = (): void => {
        this.setState({
            errors: new Array<string>(),
            focusing: true
        });
    }

    render(): JSX.Element {
        const { id, extendClass, value: originValue, type, children, label, mask, placeHolder, inputCheck, password, disabled, headIcon, errorMessage, autoComplete } = this.props;
        const { errors, focusing } = this.state;
        const additionalClass = extendClass ? extendClass : ['', ''];
        const value = headIcon ? `${headIcon} ${originValue}` : originValue;

        return (
            <Tooltip
                wrapper="div"
                // wrap="div"
                title={(errorMessage && errorMessage != '') ? errorMessage : errors.length > 0 ? label + errors.join(',') : ''}
                className={(errors.length > 0 ? 'has-error' : '') + (additionalClass[0] && (' ' + additionalClass[0]))}
                isValidation={true}
            >
                {children}
                {
                    inputCheck ?
                        <div className={'input-group' + (additionalClass[1] && (' ' + additionalClass[1]))}>
                            <InputMask
                                {...id ? { id: id } : {}}
                                className="form-control"
                                {...placeHolder ? { placeholder: placeHolder } : {}}
                                mask={mask ? mask : ''}
                                value={value ? value : ''}
                                type={type}
                                onChange={this.handleChange}
                                onBlur={this.handleBlur}
                                onFocus={this.handleFocus}
                                {...this.props.onKeyPress ? { onKeyPress: this.props.onKeyPress } : {}}
                                {...password ? { password: password } : {}}
                                disabled={disabled}
                            />
                            <div style={{ width: '25px' }} className="input-group-addon">
                                {!focusing && !isNumber(value) && (value || '').length > 0 ? inputCheck : null}
                            </div>
                        </div> :
                        <InputMask
                            {...id ? { id: id } : {}}
                            className={'form-control' + (additionalClass[1] && (' ' + additionalClass[1]))}
                            {...placeHolder ? { placeholder: placeHolder } : {}}
                            mask={mask ? mask : ''}
                            value={value ? value : ''}
                            type={type}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            onFocus={this.handleFocus}
                            {...this.props.onKeyPress ? { onKeyPress: this.props.onKeyPress } : {}}
                            {...password ? { password: password } : {}}
                            disabled={disabled}
                            autoComplete={autoComplete}
                        />
                }
            </Tooltip>
        );
    }
}

export default InputBox;


// WEBPACK FOOTER //
// ./src/components/shared/InputBox/InputBox.tsx